module.exports = __webpack_public_path__ + "static/media/rsz_boba.0253d85d.webp";